import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { ExportedFile, ExportOptions, ExportRequest } from '../types/Filters';
import { saveFile } from '../utils/download';

export function useSpreadsheetExport<TRequest extends ExportRequest = ExportRequest>(
  download: (options: TRequest & Pick<ExportOptions, 'language'>) => Promise<ExportedFile>,
  fallbackName: string,
) {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage === 'en-US' ? 'en-US' : 'pt-BR';

  return useMutation({
    mutationFn: (request: TRequest) => download({ ...request, language }),
    onSuccess: ({ file, fileName }, { format }) =>
      saveFile(file, fileName ?? `${fallbackName}.${format}`),
  });
}

export type SpreadsheetExport<TRequest extends ExportRequest = ExportRequest> = ReturnType<
  typeof useSpreadsheetExport<TRequest>
>;
